import { render, staticRenderFns } from "./FranqueadorRevisao.vue?vue&type=template&id=725479bb&scoped=true"
import script from "./FranqueadorRevisao.vue?vue&type=script&lang=js"
export * from "./FranqueadorRevisao.vue?vue&type=script&lang=js"
import style0 from "./FranqueadorRevisao.vue?vue&type=style&index=0&id=725479bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725479bb",
  null
  
)

export default component.exports